// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.additional-completion-modal-background {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.additional-completion-modal {
  width: 330px;
  background-color: white;
  padding: 20px;
  border-radius: 12px;
}
.additional-completion-modal__head {
  text-align: center;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: #333333;
  margin-top: 20px;
}
.additional-completion-modal__subhead {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #505054;
  margin-top: 15px;
}
.additional-completion-modal__button {
  margin-top: 50px;
}`, "",{"version":3,"sources":["webpack://./src/components/checklist/additional-completion-modal/additional-completion-modal.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AACJ;;AAEA;EACI,YAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;AACJ;AACI;EACI,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EAEA,gBAAA;AAAR;AAGI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EAEA,gBAAA;AAFR;AAKI;EACI,gBAAA;AAHR","sourcesContent":[".additional-completion-modal-background {\n    position: fixed;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.6);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 100;\n}\n\n.additional-completion-modal {\n    width: 330px;\n    background-color: white;\n    padding: 20px;\n    border-radius: 12px;\n\n    &__head {\n        text-align: center;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 18px;\n        line-height: 24px;\n        text-align: center;\n        color: #333333;\n\n        margin-top: 20px;\n    }\n\n    &__subhead {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        text-align: center;\n        color: #505054;\n\n        margin-top: 15px;\n    }\n\n    &__button {\n        margin-top: 50px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
